export default __webpack_public_path__ + "b795221ec0a898842e4ad66029c1cd2b.webp";